import React, { useEffect, useState, useRef } from "react";
import { SyncBadge } from "../../common/badges";
import BrightnessBar from "../common/brightness-bar";

const Brightness1Widget = ({ widget, onValueUpdate, pattern }) => {
  const [brightness, setBrightness] = useState(0);
  const [w1, setW1] = useState({});
  const [minMax, setMinMax] = useState({ min: 0, max: 100 });
  const sliderRef = React.useRef(null);
  const lastValueRef = useRef(null);

  useEffect(() => {
    if (widget?.items?.$w1) {
      const initialValue = Number(widget.items.$w1.value);
      const validValue = isNaN(initialValue) ? 0 : initialValue;
      setMinMax({
        min: widget.items.$w1.min ?? 0,
        max: widget.items.$w1.max ?? 100,
      });
      setBrightness(validValue);
      lastValueRef.current = validValue;
    }
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    if (data === lastValueRef.current) return;
    console.debug("data", data);
    const updatedWidget = {
      ...widget.items.$w1,
      value: data,
    };
    lastValueRef.current = data;
    onValueUpdate(updatedWidget);
  };

  const handleBrightnessChange = (event, newValue) => {
    event.stopPropagation();
    const adjustedValue = Math.min(Math.max(newValue, minMax.min), minMax.max);
    setBrightness(adjustedValue);
  };

  return (
    <div
      className="w-full relative rounded-2xl overflow-hidden"
      style={{
        height: "40px",
      }}
    >
      {pattern && pattern.endsWith("_W") && <SyncBadge />}
      {w1 && (
        <BrightnessBar
          value={brightness}
          onChange={handleBrightnessChange}
          disabled={pattern && pattern.endsWith("_R")}
          onValueUpdate={handleValueUpdate}
          min={minMax.min}
          max={minMax.max}
          sliderRef={sliderRef}
        />
      )}
    </div>
  );
};

export default Brightness1Widget;
